import { render, staticRenderFns } from "./QuoteStatusChip.vue?vue&type=template&id=1c010755"
import script from "./QuoteStatusChip.vue?vue&type=script&lang=js"
export * from "./QuoteStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports